/**
 * Create a smooth transition between two values.
 *
 * @param  {Number} current        Current value.
 * @param  {Number} target         Target value.
 * @param  {Number} [smoothing=10] Smoothing amount. A larger number = more iterations to complete the transition.
 * @return {Number}
 */
Math.smooth = function( current, target, smoothing ) {

	if ( ! smoothing ) {
		smoothing = 10;
	}

	var step = ( target - current ) / smoothing;

	// Step is small so let's finish the transition and reach the target.
	if ( Math.abs( step ) < 0.01 ) {
		return target;
	}

	return current + step;

};


Math.distance = function( x1, y1, x2, y2 ) {

	var a = x1 - x2;
	var b = y1 - y2;

	return Math.sqrt( ( a * a )  + ( b * b ) );

};